import { render, staticRenderFns } from "./ReorderContactProfile.vue?vue&type=template&id=829f2b16&"
import script from "./ReorderContactProfile.vue?vue&type=script&lang=ts&"
export * from "./ReorderContactProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports